import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import ViewOnDesktopCard from '../components/ViewOnDesktopCard'

// Event/Outing setup is pre-launch. The legacy 3-day annual-outing admin tabs
// (Event / Players / Groups / Scores / Teams / Courses) were RETIRED in the
// D-341 Phase-3 cutover: they read the dropped events.status / active_round /
// per-day course+tee-time columns. Live event administration now happens in
// EventDraftAdmin (the draft wizard + organizer console) off the event page.
// This route stays as the "Coming Soon" placeholder it already rendered.
export default function CommissionerPage() {
  const navigate = useNavigate()
  const { player } = useAuth()
  const canCreateEvents = player?.role === 'organization' || player?.role === 'course' || player?.role === 'admin'
  const pageTitle = canCreateEvents ? 'Event Setup' : 'Outing Setup'

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <div className="eyebrow">Admin Panel</div>
          <div className="flex justify-between items-center">
            <h1>{pageTitle}</h1>
            <button className="btn btn-ghost btn-sm" onClick={() => navigate('/')}>← Home</button>
          </div>
        </div>

        {/* COMING SOON banner — outing/event setup is pre-launch placeholder */}
        <div style={{
          background: 'linear-gradient(180deg, #c9a84c 0%, #b8952e 100%)',
          color: '#1b2a1f',
          textAlign: 'center',
          padding: '24px 16px',
          borderRadius: 12,
          marginBottom: 16,
          fontFamily: 'var(--font-display)',
          fontSize: '1.8rem',
          fontWeight: 800,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
        }}>
          Coming Soon
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '0.78rem', fontWeight: 400, letterSpacing: '0.02em', textTransform: 'none', marginTop: 6, opacity: 0.85 }}>
            {pageTitle} tools are on the way.
          </div>
        </div>

        <ViewOnDesktopCard
          title="Build & export on desktop"
          description="Large rosters, multi-day setup, and the results export portal are far easier on the web dashboard."
          path="/commissioner/export"
          cta="Open export portal on desktop"
        />
      </div>
    </div>
  )
}
